// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1RgmF","title":"Images45_title__vccjw","images":"Images45_images__iI4rf"};